/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Monitoring = {

	delete (context, monitoringId, onSuccess, onError, options) {
		Api.delete(context,
			"/monitoring"
			+ "?monitoringId=" + monitoringId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteAttachment (context, monitoringId, index, onSuccess, onError, options) {
		Api.delete(context,
			"/monitoring/attachment"
			+ "?monitoringId=" + monitoringId
			+ "&index=" + index
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, monitoringId, onSuccess, onError, options) {
		Api.get(context,
			"/monitoring"
			+ "?monitoringId=" + monitoringId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAttachment (context, monitoringId, index, onSuccess, onError, options) {
		Api.get(context,
			"/monitoring/attachment"
			+ "?monitoringId=" + monitoringId
			+ "&index=" + index
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/monitoring/configuration"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/monitoring/list"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPossibleUsers (context, onSuccess, onError, options) {
		Api.get(context,
			"/monitoring/possible-users"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/monitoring"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAttachment (context, monitoringId, file, onSuccess, onError, options) {
		Api.post(context,
			"/monitoring/attachment"
			+ "?monitoringId=" + monitoringId
			+ "&file=" + file
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportBySearchCriteria (context, contestId, projectReportExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/monitoring/export-by-search-criteria"
			+ "?contestId=" + contestId
			, projectReportExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, monitoringId, data, onSuccess, onError, options) {
		Api.put(context,
			"/monitoring"
			+ "?monitoringId=" + monitoringId
			, data
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, monitoringId, data, onSuccess, onError, options) {
		Api.put(context,
			"/monitoring/finish"
			+ "?monitoringId=" + monitoringId
			, data
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
